const GetFailureConfig = 
  `
  query {
    failureConfig {
      componentFailureConfigs {
        component
        failureRate
      }
    }	
  }  
  `

const SetFailureConfig = (configs) => {
  const configMap = configs.map(({ component, failureRate }) => {  
    return `{
      component: ${component}
      failureRate: ${failureRate}
    }`
  }).join('')
  
  return `
    mutation {
      failureConfig(input: {
        componentFailureConfigs: [
          ${configMap}
        ]
      }) {
        success
        errorMessage
      }
    }
    `  
}

module.exports = {
  GetFailureConfig,
  SetFailureConfig,
}